module.exports = __webpack_public_path__ + "static/add_todoist_menu-cc9d69477fc6cf12056e6f719fb34dd1.png";